"use client";

import { useState } from "react";
import Image, { ImageProps } from "next/image";

interface ImageWithSkeletonProps extends ImageProps {
  skeletonClassName?: string;
}

const ImageWithSkeleton = ({
  skeletonClassName,
  className,
  onLoad,
  alt,
  ...props
}: ImageWithSkeletonProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setIsLoading(false);
    onLoad?.(e);
  };

  return (
    <div className="relative w-full h-full">
      {isLoading && (
        <div
          className={`absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse ${
            skeletonClassName ?? ""
          }`}
        />
      )}
      <Image
        {...props}
        alt={alt ?? ""}
        className={className}
        onLoad={handleLoad}
      />
    </div>
  );
};

export default ImageWithSkeleton;
